import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CartButton from './CartButton.vue';
// import CommonButton from './CommonButton.vue';
import CartModal from './modals/CartModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props, { expose: __expose }) {
  __expose();

const cartModal = ref<InstanceType<typeof CartModal>>();

const scrollTop = ref(0);

window.addEventListener('scroll', () => scrollTop.value = window.scrollY);


const __returned__ = { cartModal, scrollTop, CartButton, CartModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})